// @flow

import React from 'react'
import styled from 'styled-components'
import theme from 'styled-theming'

import { Navigation, NavigationItem } from '../../components/navigation'

import route from '../../data/routes'
import { myTheme } from '../../styles'

const { color, space } = myTheme

const borderColor = theme('mode', {
  dark: color.lightBlueGray,
  light: color.offWhite,
})
const NavContainer = styled.div`
  margin-top: ${space.three};
  border-top: 1px solid ${borderColor};
  display: ${props => props.disabled && 'none'};
`

type Props = {
  disabled: boolean,
}

const WorksNavigation = ({ disabled }: Props) => (
  <NavContainer disabled={disabled}>
    <Navigation>
      <NavigationItem to={route.mavenPro}>Maven Pro</NavigationItem>
    </Navigation>
  </NavContainer>
)

export default WorksNavigation



// WEBPACK FOOTER //
// ./src/scenes/works/works-navigation.js